import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTaskV2ArchivedListComponent } from './fi-task-v2-archived-list.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiSideListNewModule } from '../../utilities/side-list-new/side-list-new.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatCardModule } from '@angular/material/card';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { FiTwoColumnsContainerModule } from '@fi-shared/fi-two-columns-container/fi-two-columns-container.module';
import { MatIconModule } from '@angular/material/icon';
import { FiTaskV2SharedComponentsModule } from '../components/fi-task-v2-shared-components.module';
import { FiLineClampModule } from '@fi-app/shared/fi-directives/fi-line-clamp/fi-line-clamp.module';
import { FiProgressBadgeModule } from '@fi-app/shared/fi-progress-badge/fi-progress-badge.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiItemsListModule,
        FiLocalSearch2Module,
        FiSideListNewModule,
        FiWrapperTableModule,
        MatCardModule,
        FiWhenScrolledModule,
        MatButtonModule,
        MatMenuModule,
        FiTwoColumnsContainerModule,
        MatIconModule,
        FiTaskV2SharedComponentsModule,
        FiLineClampModule,
        FiProgressBadgeModule,
    ],
    declarations: [FiTaskV2ArchivedListComponent],
})
export class FiTaskV2ArchivedListModule {}
